import { adminApi as generatedAdminApi } from '@/store/codegen/generated/adminApi'

export const idpUserApi = generatedAdminApi.enhanceEndpoints({
  addTagTypes: ['idpUser'],
  endpoints: {
    listIdpUsers: {
      providesTags: (result, error) => {
        return (
          result
            ? [
                ...result.idpUsers.map(({ idpId, userId }) => ({ type: 'idpUser', id: `${idpId}-${userId}` })),
                // PARTIAL-LIST denotes that the list is partial, which is paginated
                { type: 'idpUser', id: 'PARTIAL-LIST' }
              ]
            : [{ type: 'idpUser', id: 'PARTIAL-LIST' }]
        )
      }
    },
    deleteIdpUser: {
      invalidatesTags: ['idpUser']
    }
  }
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useListIdpUsersQuery,
  useDeleteIdpUserMutation
} = idpUserApi
